import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectDashboardComponent } from './project-dashboard/project-dashboard.component';
import { ProjectDetailComponent } from './project-detail/project-detail.component';
import { ProjectsListComponent } from './projects-list/projects-list.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { RoleGuardGuard } from 'src/app/auth/role-guard.guard';
import { SearchpageComponent } from '../searchpage/searchpage.component';
import { UserRoles } from 'src/app/enums/userRoles.enum';

const routes: Routes = [
  {
    path: 'addProject',
    component: ProjectDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'Home/KMSPortal/Pending Approvals/View/:id',
    component: ProjectDetailComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: "Home/KMSPortal/PendingApporval/View"
    }
  },
  {
    path: 'Home/KMSPortal/Pending Approvals',
    component: ProjectDashboardComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: [UserRoles.SuperAdmin, UserRoles.Admin, UserRoles.ContentManager],
      preload: true,
      breadcrumb: 'Home/KMS Portal/pending Approvals'
    }
  },
  {
    path: 'projectsList',
    component: ProjectsListComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: [UserRoles.SuperAdmin, UserRoles.Admin, UserRoles.ContentManager],
      preload: true,
      breadcrumb: 'Home/KMS Portal/Project Content'
    }
  },
  {
    path: 'KMSPortal',
    component: SearchpageComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/KMS Portal'
    }
  },
  {
    path: 'Home/KMSPortal/Project Content',
    component: ProjectsListComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/KMS Portal/Project Content',
      roles: ['SuperAdmin', 'Admin', 'Leadership'],
    },
  },
  {
    path: 'ICT',
    loadChildren: () => import('../ict-project/ict-projects.module').then(m => m.IctProjectsModule)
  }
];



@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectsRoutingModule { }
